import React from 'react'
import { Tag } from "antd";

const AppointmentTags = ({status, report}) => {

    return(
        <React.Fragment>
            {status === 'WAITING' ? <Tag color={"cyan"}>BEKLEMEDE</Tag> :
                status === 'POSITIVE' ? <Tag color={"green"}>OLUMLU </Tag> :
                    status === 'NEGATIVE' ? <Tag color={"red"}>OLUMSUZ</Tag> : null
            }
            {report === null ? <Tag color={"purple"}>SONUÇ GİRİLMEDİ</Tag> : null}
        </React.Fragment>
    )
}
export default AppointmentTags